import { createRoute, Navigate } from "@tanstack/react-router";
import { InvitationExpiredPage } from "pages/app/InvitationExpiredPage";

import { rootRoute } from "../rootRoute";

// Legacy auth paths redirect to the new /auth/* routes. Rails also redirects at the server
// level (config/routes.rb), but the SPA route handles in-app navigations that skip the server.

// Rails already renames `destination` → `redirect` on full-page loads; this covers in-app navigations
// which should never happen but doing this as a safety measure.
function renameDestinationToRedirect(prev: Record<string, unknown>) {
  const { destination, ...rest } = prev;
  return destination ? { ...rest, redirect: destination } : rest;
}

export const preAuthLoginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/sign_in",
  staticData: { pageName: "Log In", headerNav: true },
  component: function PreAuthLoginRedirect() {
    return <Navigate to="/auth/login" search={renameDestinationToRedirect} replace />;
  },
});

export const preAuthSignupRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/get-started",
  staticData: { pageName: "Get Started", headerNav: true },
  component: function PreAuthSignupRedirect() {
    return <Navigate to="/auth/register" search={renameDestinationToRedirect} replace />;
  },
});

export const invitationExpiredRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/invitation_expired",
  staticData: { pageName: "Onboarding - Invitation Expired", headerNav: true },
  component: InvitationExpiredPage,
});

// Flat list of sibling routes (not a single subtree), so it's spread into the route tree.
export const authRoutes = [preAuthLoginRoute, preAuthSignupRoute, invitationExpiredRoute];
